import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { MATERIALS } from "@/data/site";
import { FadeUp, Chapter, RevealLines, EASE } from "./motion";

export default function Materials() {
  const [open, setOpen] = useState(0);
  return (
    <section id="materials" data-testid="materials-section" className="bg-[#F7F5F2] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="09" title="Material Library" />
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <RevealLines
            className="font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
            lines={[<>Only materials</>, <>worth <span className="italic text-[#B68D40]">keeping.</span></>]}
          />
          <FadeUp delay={0.3}>
            <p className="max-w-sm text-sm leading-relaxed text-[#2C2C2C]/65">
              Every finish in your home is chosen from a library we have tested, touched and trusted for years.
            </p>
          </FadeUp>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {MATERIALS.map((m, i) => {
            const isOpen = open === i;
            return (
              <FadeUp key={m.name} delay={(i % 3) * 0.08}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`material-${m.name.toLowerCase().replace(/\s/g, "-")}`}
                  className={`block w-full rounded-xl border p-7 text-left transition-colors duration-300 ${
                    isOpen ? "border-[#B68D40] bg-[#1B1B1B]" : "hairline bg-white hover:border-[#B68D40]/50"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <div>
                      <p className={`font-num text-[10px] uppercase tracking-[0.3em] ${isOpen ? "text-[#B68D40]" : "text-[#2C2C2C]/45"}`}>{m.tag}</p>
                      <h3 className={`mt-2 font-display text-2xl ${isOpen ? "text-[#F7F5F2]" : "text-[#1B1B1B]"}`}>{m.name}</h3>
                    </div>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.35, ease: EASE }}
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border ${isOpen ? "border-[#B68D40] text-[#B68D40]" : "hairline text-[#2C2C2C]/50"}`}
                    >
                      <Plus size={15} />
                    </motion.span>
                  </div>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: EASE }}
                        className="overflow-hidden"
                      >
                        <p className="mt-4 text-sm leading-relaxed text-[#F7F5F2]/70">{m.desc}</p>
                        <p className="mt-4 border-t border-[#F7F5F2]/10 pt-4 font-num text-[10px] uppercase tracking-[0.25em] text-[#B68D40]">{m.brands}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </button>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
